import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { OverdueDeliveryService } from '../shared/overdue-delivery.service';
import { defaultCriteria, OverdueDeliveryCriteria } from '../shared/overdue-delivery-criteria.model';
import { forkJoin, interval, of, Subscription } from 'rxjs';
import { LoaderService } from '../../shared/services/loader.service';
import { catchError, filter, finalize, map, switchMap } from 'rxjs/operators';
import {
  OverdueCollectionProductType,
  OverdueCollectionType,
  OverdueDelivery,
  OverdueDeliveryIndicator
} from '../shared/overdue-delivery.model';
import { OverdueMetrics } from '../shared/overdue-metrics.model';
import { Carrier } from '../../user-dashboard/shared/carrier.model';
import { Region } from '../../user-dashboard/shared/region.model';
import { CountryService } from '../../user-dashboard/shared/country.service';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { CheckboxOption } from '../../shared/data-filters/data-filter-checkbox/data-filter-checkbox.component';
import { DataTableColumn, DataTableComponent } from '../../shared/data-table/data-table.component';
import { OverdueType } from '../shared/overdue-type';
import * as moment from 'moment/moment';
import {min, Moment} from 'moment';
import { Option } from '../../shared/data-filters/data-filter-select/data-filter-select.component';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { ModalService } from '../../shared/services/modal.service';
import {
  OverdueLoadAction,
  OverdueLoadActionRequest,
  OverdueLoadActionStatus,
  OverdueLoadActionType,
} from '../shared/overdue-load-action.model';
import { TranslateService } from '@ngx-translate/core';
import { ECalendarValue, IDatePickerDirectiveConfig } from 'ng2-date-picker';
import { HttpErrorResponse } from '@angular/common/http';
import { Country } from '../../user-dashboard/shared/country.model';
import { LOCAL_STORAGE_KEYS } from '../../core/constants';
import { CarrierService } from '../../user-dashboard/shared/carrier.service';
import { NavigationLinkService } from '../../shared/services/navigation-link.service';

@Component({
  selector: 'app-overdue-delivery-list',
  templateUrl: './overdue-delivery-list.component.html',
  styleUrls: ['./overdue-delivery-list.component.scss']
})
export class OverdueDeliveryListComponent implements OnInit, AfterViewInit, OnDestroy {

  public selectedRegion: Region;
  public selectedCarrier: Carrier;

  accessibleCountries: Country[] = [];
  countriesOptions: Option[] = [];

  isGlobalUser = this.authService.canUseGlobalOverdue();

  @ViewChild(DataTableComponent, { static : true })
  overdueTable: DataTableComponent;

  criteria: OverdueDeliveryCriteria = defaultCriteria;
  appliedCriteria: any = null;
  productTypeOptions: Option[] = [
    { labelKey: 'overdue-process.filters.labels.all', value: OverdueCollectionProductType.ALL },
    { labelKey: 'overdue-process.filters.labels.product-type.au', value: OverdueCollectionProductType.AU },
    { labelKey: 'overdue-process.filters.labels.product-type.cc', value: OverdueCollectionProductType.CC },
    { labelKey: 'overdue-process.filters.labels.product-type.pa', value: OverdueCollectionProductType.PA },
  ];
  typeOptions: Option[] = [
    { labelKey: 'overdue-process.filters.labels.national', value: OverdueCollectionType.NATIONAL},
    { labelKey: 'overdue-process.filters.labels.international', value: OverdueCollectionType.INTERNATIONAL},
    { labelKey: 'overdue-process.filters.labels.both', value: OverdueCollectionType.BOTH}
  ];
  pickedOptions: Option[] = [
    { labelKey: 'overdue-process.filters.labels.picked', value: true},
    { labelKey: 'overdue-process.filters.labels.not-picked', value: false},
    { labelKey: 'overdue-process.filters.labels.both', value: OverdueCollectionType.BOTH},
  ];
  blockedOptions: Option[] = [
    { labelKey: 'overdue-process.filters.labels.blocked', value: true},
    { labelKey: 'overdue-process.filters.labels.not-blocked', value: false},
    { labelKey: 'overdue-process.filters.labels.both', value: OverdueCollectionType.BOTH},
  ];
  sotOptions: Option[] = [
    { labelKey: 'overdue-process.filters.labels.yes', value: true},
    { labelKey: 'overdue-process.filters.labels.no', value: false},
    { labelKey: 'overdue-process.filters.labels.both', value: OverdueCollectionType.BOTH},
  ];
  carrierOptions: Option[] = [
    { labelKey: 'overdue-process.filters.labels.yes', value: true},
    { labelKey: 'overdue-process.filters.labels.no', value: false},
    { labelKey: 'overdue-process.filters.labels.both', value: OverdueCollectionType.BOTH},
  ];
  filterMode: OverdueType = OverdueType.CUSTOM;
  FilterMode = OverdueType;
  showFilters = true
  advancedMode = 'search';
  lastActionBefore: Moment;
  lastActionAfter: Moment;
  lastActionType: any[] = ['CHEP', 'CARRIER'];
  lastActionTypeOptions: CheckboxOption[] = [
    {labelKey: 'overdue-process.filters.action.type-chep', value: 'CHEP'},
    {labelKey: 'overdue-process.filters.action.type-carrier', value: 'CARRIER'},
  ];


  actionTypes: Option[];
  multiActionTypes: Option[];
  actionType: OverdueLoadActionType;
  proposedDeliveryDate: Moment | string;
  deliveryDateError = true;
  proposedGiDate: Moment | string;
  giDateError = true;
  duplicatedDeliveryNumber: string;
  duplicatedDeliveryNumberError = true;
  validPODinTMS: boolean;
  validPODinTMSError = true;
  commentary: string;
  commentaryError = true;
  approved: boolean = null;
  selectedDeliveries: OverdueDelivery[] = [];
  multiActionModalSelectedDelivery: string;

  columns: DataTableColumn[] = [];

  @ViewChild('numberColumn', { static : true })
  numberColumn: TemplateRef<any>;
  @ViewChild('priorityColumn', { static : true })
  priorityColumn: TemplateRef<any>;
  @ViewChild('carrierColumn', { static : true })
  carrierColumn: TemplateRef<any>;
  @ViewChild('originColumn', { static : true })
  originColumn: TemplateRef<any>;
  @ViewChild('destinationColumn', { static : true })
  destinationColumn: TemplateRef<any>;
  @ViewChild('deliveryDateColumn', { static : true })
  deliveryDateColumn: TemplateRef<any>;
  @ViewChild('GIDateColumn', { static : true })
  GIDateColumn: TemplateRef<any>;
  @ViewChild('deadlineColumn', { static : true })
  deadlineColumn: TemplateRef<any>;
  @ViewChild('pickedColumn', { static : true })
  pickedColumn: TemplateRef<any>;
  @ViewChild('sotColumn', { static : true })
  sotColumn: TemplateRef<any>;
  @ViewChild('productsColumn', { static : true })
  productsColumn: TemplateRef<any>;
  @ViewChild('overdueColumn', { static : true })
  overdueColumn: TemplateRef<any>;

  @ViewChild('reviewModal')
  reviewModal: TemplateRef<any>;
  @ViewChild('editModal')
  editModal: TemplateRef<any>;
  @ViewChild('updateModal')
  updateModal: TemplateRef<any>;
  @ViewChild('updateMultiModal')
  updateMultiModal: TemplateRef<any>;
  @ViewChild('editMultiModal')
  editMultiModal: TemplateRef<any>;
  metricsResult: OverdueMetrics = null;


  OverdueDeliveryIndicator = OverdueDeliveryIndicator;
  OverdueLoadActionType = OverdueLoadActionType;
  OverdueLoadActionStatus = OverdueLoadActionStatus;

  datePickerConfigDeliveryDate: IDatePickerDirectiveConfig = {
    appendTo: '.value-wrapper',
    drops: 'down',
    firstDayOfWeek: 'mo',
    format: 'YYYY-MM-DD',
    max: null,
    min: null,
    returnedValueType: ECalendarValue.Moment,
    disableKeypress: true,
  };

  datePickerConfigGIDate: IDatePickerDirectiveConfig = {
    appendTo: '.value-wrapper',
    drops: 'down',
    firstDayOfWeek: 'mo',
    format: 'YYYY-MM-DD',
    max: null,
    min: null,
    returnedValueType: ECalendarValue.Moment,
    disableKeypress: true,
  };

  automaticRefreshSubscription: Subscription = new Subscription();
  loadPage;
  deliveryDateDisabled = false;
  giDateDisabled: boolean;
  deliveryTooLateError: boolean;
  giTooLateError: boolean;

  loadPageSearch = (p: number, pSize: number) => {
    this.overdueDeliveryService.getMetrics(this.criteria)
      .subscribe(metrics => this.metricsResult = metrics);
    this.automaticRefresh();
    return this.overdueDeliveryService.searchOverdueDeliveries(p, pSize, this.criteria, this.isGlobalUser);
  }

  loadPageAction = (p: number, pSize: number) => {
    this.automaticRefresh();
    return this.overdueDeliveryService.searchDeliveriesByAction(
      p,
      pSize,
      this.criteria,
      this.lastActionAfter,
      this.lastActionBefore,
      this.lastActionType,
      this.isGlobalUser
    );
  }

  constructor(
    private overdueDeliveryService: OverdueDeliveryService,
    private countryService: CountryService,
    private carrierService: CarrierService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
    private authService: AuthenticationService,
    private modalService: ModalService,
    private loaderService: LoaderService,
    private translate: TranslateService,
    public link: NavigationLinkService,
  ) {
    this.switchAdvanceMode(localStorage.getItem(LOCAL_STORAGE_KEYS.OVERDUE_SEARCH_MODE) || 'search');
  }

  ngOnInit() {
    this.columns = [
      {
        name: 'Number',
        displayed: true,
        translationKey: 'overdue-process.table.number',
        template: this.numberColumn,
        sortable: false
      },
      {
        name: 'priority',
        displayed: true,
        translationKey: 'overdue-process.table.priority',
        template: this.priorityColumn,
        sortable: false
      },
      {
        name: 'carrier',
        displayed: true,
        translationKey: 'overdue-process.table.carrier',
        template: this.carrierColumn,
        sortable: false
      },
      {
        name: 'origin',
        displayed: true,
        translationKey: 'overdue-process.table.origin',
        template: this.originColumn,
        sortable: false
      },
      {
        name: 'destination',
        displayed: true,
        translationKey: 'overdue-process.table.destination',
        template: this.destinationColumn,
        sortable: false
      },
      {
        name: 'deliveryDate',
        displayed: true,
        translationKey: 'overdue-process.table.delivery-date',
        template: this.deliveryDateColumn,
        sortable: false
      },
      {
        name: 'GIDate',
        displayed: true,
        translationKey: 'overdue-process.table.GI-date',
        template: this.GIDateColumn,
        sortable: false
      },
      {
        name: 'deadline',
        displayed: true,
        translationKey: 'overdue-process.table.delivery-deadline',
        template: this.deadlineColumn,
        sortable: false
      },
      {
        name: 'picked',
        displayed: true,
        translationKey: 'overdue-process.table.picked',
        template: this.pickedColumn,
        sortable: false
      },
      {
        name: 'sot',
        displayed: true,
        translationKey: 'overdue-process.table.sot',
        template: this.sotColumn,
        sortable: false
      },
      {
        name: 'products',
        displayed: true,
        translationKey: 'overdue-process.table.products',
        template: this.productsColumn,
        sortable: false,
        overflowVisible: true
      },
      {
        name: 'overdue',
        displayed: true,
        translationKey: 'overdue-process.table.overdue',
        template: this.overdueColumn,
        sortable: false
      }
    ];

    forkJoin([
      this.translate.get('overdue-process.action-modal.actions.reasons.holiday'),
      this.translate.get('overdue-process.action-modal.actions.reasons.duplicate'),
      this.translate.get('overdue-process.action-modal.actions.reasons.complete'),
      this.translate.get('overdue-process.action-modal.actions.reasons.other'),
      this.translate.get('overdue-process.action-modal.actions.reasons.problem')
    ]).subscribe(values => {
      this.actionTypes = [
        { label: values[0], value: OverdueLoadActionType.HOLIDAY },
        { label: values[1], value: OverdueLoadActionType.DUPLICATE },
        { label: values[2], value: OverdueLoadActionType.COMPLETE },
        { label: values[3], value: OverdueLoadActionType.OTHER },
        { label: values[4], value: OverdueLoadActionType.PROBLEM }
      ];

      this.multiActionTypes = [
        { label: values[0], value: OverdueLoadActionType.HOLIDAY },
        { label: values[2], value: OverdueLoadActionType.COMPLETE },
        { label: values[3], value: OverdueLoadActionType.OTHER }
      ]
    });
  }

  ngAfterViewInit(): void {
    this.resetFilters();
    this.resetModalData();
  }

  toggleProductInfo(id: string, close?: boolean) {
    const detail = document.getElementById('product-detail-' + id);
    if (detail.style.display === 'block' || close) {
      // waiting for the eventual click event on info icon event to process
      setTimeout(() => detail.style.display = 'none', 100);
    } else {
      detail.style.display = 'block';
      document.getElementById('product-detail-' + id).focus();
    }
  }

  toggleSingleUpdateRequestModal(delivery: OverdueDelivery) {
    this.overdueDeliveryService.fetchHistory(delivery.deliveryNumber)
      .pipe(
        switchMap(response => {
          return this.modalService.open({
            title: this.translate.instant('overdue-process.action-modal.update.title-update',
              {deliveryNumber: delivery.deliveryNumber}),
            content: this.updateModal,
            size: 'lg',
            data: { history: response },
            validateButton: {text: this.translate.instant('overdue-process.action-modal.actions.send')}
          })
        }),
        map(() => this.generateOverdueLoadInfoRequest(delivery)),
        switchMap(actionRequest => this.overdueDeliveryService.sendActionRequest(this.isGlobalUser, actionRequest)
            .pipe(map(() => this.overdueTable.changePage(this.overdueTable.page)))
        ),
        finalize(() => this.resetModalData())
      ).subscribe();
  }

  toggleMultipleUpdateRequestModal(deliveries: OverdueDelivery[]) {
    const deliveriesNumber = deliveries.map(delivery => delivery.deliveryNumber);
    this.multiActionModalSelectedDelivery = deliveries[0].deliveryNumber;
    const historiesObservable = deliveries.reduce((acc, delivery) =>
      ({...acc, [delivery.deliveryNumber]: this.overdueDeliveryService.fetchHistory(delivery.deliveryNumber)}), {});

    this.overdueDeliveryService.hasMultipleLastActionToReview(deliveriesNumber)
      .pipe(
        filter(hasMultipleActionPending => !hasMultipleActionPending),
        switchMap(() => forkJoin(historiesObservable)),
        switchMap((response: {[key: string]: OverdueLoadAction[]}) => {
          return this.modalService.open({
            title: this.translate.instant('overdue-process.action-modal.mass-update.title',
              {deliveriesNumber: deliveries.map(delivery => delivery.deliveryNumber).join(', ')}),
            content: this.updateMultiModal,
            size: 'lg',
            data: { deliveriesNumber: Object.keys(response), historiesByDeliveryNumber: response },
            validateButton: {text: this.translate.instant('overdue-process.action-modal.actions.send')}
          })
        }),
        map(() => deliveries.map(delivery => this.generateOverdueLoadInfoRequest(delivery))),
        switchMap((actions: OverdueLoadActionRequest[]) => this.overdueDeliveryService.sendMultiActionRequest(this.isGlobalUser, actions)
          .pipe(map(() => this.overdueTable.changePage(this.overdueTable.page)))
        ),
        finalize(() => this.resetModalData())
      ).subscribe();
  }


  initializeDatePickersMinAt(time: Moment) {
    this.datePickerConfigDeliveryDate.min = time;
    this.datePickerConfigDeliveryDate = { ...this.datePickerConfigDeliveryDate };
    this.datePickerConfigGIDate.min = time;
    this.datePickerConfigGIDate = { ...this.datePickerConfigGIDate };
  }

  initializeGiDateMaxWithDeliveries(deliveries: OverdueDelivery[], carrierDto: Carrier) {
    this.datePickerConfigGIDate.max = min(deliveries.map(el => el.deliveryGiDate))
      .clone()
      .add(carrierDto.region.features.overdueMaxDaysUpdate, 'days');
    this.datePickerConfigGIDate = { ...this.datePickerConfigGIDate };
  }

  initializeDeliveryDateMaxWithDeliveries(deliveries: OverdueDelivery[], carrierDto: Carrier) {
    this.datePickerConfigDeliveryDate.max = min(deliveries.map(el => el.deliveryDate))
      .clone()
      .add(carrierDto.region.features.overdueMaxDaysUpdate, 'days');
    this.datePickerConfigDeliveryDate = { ...this.datePickerConfigDeliveryDate };
  }

  initializeGiDateMaxWithDelivery(delivery: OverdueDelivery, carrierDto: Carrier) {
    this.datePickerConfigGIDate.max = delivery
      .deliveryGiDate
      .clone()
      .add(carrierDto.region.features.overdueMaxDaysUpdate, 'days');
    this.datePickerConfigGIDate = { ...this.datePickerConfigGIDate };
  }

  initializeDeliveryDateMaxWithDelivery(delivery: OverdueDelivery, carrierDto: Carrier) {
    this.datePickerConfigDeliveryDate.max = delivery
      .deliveryDate
      .clone()
      .add(carrierDto.region.features.overdueMaxDaysUpdate, 'days');
    this.datePickerConfigDeliveryDate = { ...this.datePickerConfigDeliveryDate };
  }

  validatesDatePickers() {
    this.deliveryDateDisabled = this.datePickerConfigDeliveryDate.max < moment().startOf('day')
    this.deliveryTooLateError = this.datePickerConfigDeliveryDate.max < moment().startOf('day')

    this.giDateDisabled = this.datePickerConfigGIDate.max < moment().startOf('day')
    this.giTooLateError = this.datePickerConfigGIDate.max < moment().startOf('day')
  }

  toggleMultipleEditModal(deliveries: OverdueDelivery[]) {
    this.deliveryDateDisabled = deliveries.some(delivery => delivery.picked)

    this.initializeDatePickersMinAt(moment());
    const carrier = deliveries
      .filter(delivery => delivery.carrierAssigned)
      .map(delivery => delivery.carrier)[0];
    this.carrierService.getByScacCodeOrVendorNumber(carrier.scacCode, carrier.vendorNumber)
      .subscribe((carrierDto) => {
        this.initializeDeliveryDateMaxWithDeliveries(deliveries, carrierDto)
        this.initializeGiDateMaxWithDeliveries(deliveries, carrierDto)
        this.validatesDatePickers()
      });
    const deliveriesNumber = deliveries.map(delivery => delivery.deliveryNumber);

    this.multiActionModalSelectedDelivery = deliveries[0].deliveryNumber;
    const historiesObservable = deliveries.reduce((acc, delivery) =>
      ({...acc, [delivery.deliveryNumber]: this.overdueDeliveryService.fetchHistory(delivery.deliveryNumber)}), {});

    this.overdueDeliveryService.hasMultipleLastActionToReview(deliveriesNumber)
      .pipe(
        filter(hasMultipleActionPending => !hasMultipleActionPending),
        switchMap(() => forkJoin({...historiesObservable})),
        switchMap((response: {[key: string]: OverdueLoadAction[]}) => {
          const {...historiesByDeliveryNumber} = response;
          return  this.modalService.open({
            title: this.translate.instant('overdue-process.action-modal.mass-edit.title', {deliveriesNumber}),
            content: this.editMultiModal,
            size: 'lg',
            data: {
              historiesByDeliveryNumber,
              deliveriesNumber: Object.keys(historiesByDeliveryNumber),
              today: moment(),
              oneIsPicked: deliveries.some(delivery => delivery.picked),
            },
            validateButton: {
              text: this.translate.instant('overdue-process.action-modal.mass-edit.confirm'),
              disabled: () => {
                for (const delivery of deliveries) {
                  if (this.checkActionModalData(delivery.deliveryDate)) {
                    return true;
                  }
                }
                return false;
              }
            },
          });
        }),
        map(() => deliveries.map(delivery => this.generateOverdueLoadActionRequest(delivery, this.actionType))),
        switchMap((actions: OverdueLoadActionRequest[]) => this.overdueDeliveryService.sendMultiActionRequest(this.isGlobalUser, actions)
          .pipe(map(() => this.overdueTable.changePage(this.overdueTable.page)))
        ),
        finalize(() => this.resetModalData())
      ).subscribe();
  }

  toggleActionModal(delivery: OverdueDelivery) {

    this.initializeDatePickersMinAt(moment());

    if (delivery.carrierAssigned) {
      this.carrierService.getByScacCodeOrVendorNumber(delivery.carrier.scacCode, delivery.carrier.vendorNumber)
        .subscribe((carrierDto) => {
          this.initializeDeliveryDateMaxWithDelivery(delivery, carrierDto)
          this.initializeGiDateMaxWithDelivery(delivery, carrierDto)
          this.validatesDatePickers()
        });
    }

    if (delivery.picked) {
      this.proposedDeliveryDate = delivery.deliveryDate.clone();
    }

    const deliveryNumber = delivery.deliveryNumber;

    forkJoin([
      this.overdueDeliveryService.fetchHistory(deliveryNumber),
      this.overdueDeliveryService.fetchLastActionToReview(deliveryNumber)
    ]).subscribe((res) => {
      if (this.isGlobalUser && res[1] !== null) {
        this.toggleReviewModal(delivery, res[0], res[1]);
      } else {
        this.toggleEditModal(delivery, res[0], res[1]);
      }
    })
  }

  toggleReviewModal(delivery: OverdueDelivery, history: OverdueLoadAction[], lastAction: OverdueLoadAction) {
    of([]).pipe(
      switchMap(() => this.modalService.open({
        title: this.translate.instant('overdue-process.action-modal.review.title-update',
          {deliveryNumber: delivery.deliveryNumber}),
        content: this.reviewModal,
        size: 'lg',
        data: { delivery: delivery.deliveryNumber, history: history, lastAction: lastAction },
        validateButton: {
          text: this.translate.instant('overdue-process.action-modal.actions.review'),
          disabled: () => this.approved === null
        }
      })),
      map(() => this.generateOverdueLoadReviewRequest(delivery, OverdueLoadActionType[lastAction.type + '_REVIEW'])),
      switchMap((data: OverdueLoadActionRequest) => this.overdueDeliveryService.sendReviewRequest(data)
        .pipe(
          map(() => this.overdueTable.changePage(this.overdueTable.page)),
          catchError(error => {
            this.errorHandler.handleHttpError(error, 'overdue-process.errors.review-action', true);
            this.overdueTable.changePage(this.overdueTable.page);
            return of([]);
          })
        )
      ),
      finalize(() => this.resetModalData())
    ).subscribe();
  }

  toggleEditModal(delivery: OverdueDelivery, history: OverdueLoadAction[], lastAction: OverdueLoadAction) {
    this.modalService.open({
      title: this.translate.instant('overdue-process.action-modal.edit.title-update',
        {deliveryNumber: delivery.deliveryNumber}),
      content: this.editModal,
      size: 'lg',
      data: {
        delivery: delivery.deliveryNumber,
        history: history,
        lastAction: lastAction,
        picked: delivery.picked,
        today: moment()
      },
      validateButton: {
        text: this.translate.instant('overdue-process.action-modal.actions.ask-edit'),
        disabled: () => this.checkActionModalData(delivery.deliveryDate)
      },
    }).pipe(
      map(() => this.generateOverdueLoadActionRequest(delivery, this.actionType)),
      switchMap((data: OverdueLoadActionRequest) => {
        if (lastAction) { return; }
        let resultObservable;
        switch (this.actionType) {
          case OverdueLoadActionType.COMPLETE:
          case OverdueLoadActionType.DUPLICATE:
            if (this.validPODinTMS) {
              resultObservable = this.overdueDeliveryService.sendActionRequest(this.isGlobalUser, data)
                .pipe(
                  map(() => this.overdueTable.changePage(this.overdueTable.page)),
                  catchError(error => {
                    this.errorHandler.handleHttpError(error, 'overdue-process.errors.review-action', true);
                    this.overdueTable.changePage(this.overdueTable.page);
                    return of([]);
                  }));
            }
            break;
          case OverdueLoadActionType.HOLIDAY:
          case OverdueLoadActionType.OTHER:
            if (!(
              moment(this.proposedDeliveryDate).isSame(delivery.deliveryDate, 'day') &&
              moment(this.proposedGiDate).isSame(delivery.deliveryGiDate, 'day')
            )) {
              resultObservable = this.overdueDeliveryService.sendActionRequest(this.isGlobalUser, data)
                .pipe(
                  map(() => this.overdueTable.changePage(this.overdueTable.page)),
                  catchError(error => {
                    this.errorHandler.handleHttpError(error, 'overdue-process.errors.review-action', true);
                    this.overdueTable.changePage(this.overdueTable.page);
                    return of([]);
                  }));
            }
            break;
          case OverdueLoadActionType.PROBLEM:
            resultObservable = this.overdueDeliveryService.sendActionRequest(this.isGlobalUser, data)
              .pipe(
                map(() => this.overdueTable.changePage(this.overdueTable.page)),
                catchError(error => {
                  this.errorHandler.handleHttpError(error, 'overdue-process.errors.review-action', true);
                  this.overdueTable.changePage(this.overdueTable.page);
                  return of([]);
                }));
        }
        return resultObservable;
      }),
      finalize(() => this.resetModalData())
    ).subscribe();
  }

  exportDeliveries() {
    this.loaderService.startLoad();
    if (this.advancedMode === 'actions') {
      this.overdueDeliveryService.exportActions(this.criteria, this.lastActionAfter, this.lastActionAfter, this.lastActionType)
        .pipe(
          catchError((error) => {
            this.errorHandler.handleHttpError(error, 'overdue-process.errors.export');
            return of(error);
          }),
          finalize(() => this.loaderService.stopLoad())
        ).subscribe();
    } else {
      this.overdueDeliveryService.exportDeliveries(this.criteria)
        .pipe(
          catchError((error) => {
            this.errorHandler.handleHttpError(error, 'overdue-process.errors.export', true);
            return of(error);
          }),
          finalize(() => this.loaderService.stopLoad())
        ).subscribe();
    }
  }

  switchFilterMode(mode: OverdueType) {
    if (this.filterMode === mode) {
      mode = OverdueType.CUSTOM;
    }
    this.softResetFilters();
    switch (mode) {
      case OverdueType.OVERDUE_NOT_PROCESSED:
        this.criteria.deliveryDeadlineBefore = moment().add(-1, 'day').startOf('day');
        this.criteria.pickCompleted = false;
        this.criteria.blocked = false;
        break;
      case OverdueType.OVERDUE_PICKED:
        this.criteria.deliveryDeadlineBefore = moment().add(-1, 'day').startOf('day');
        this.criteria.pickCompleted = true;
        this.criteria.blocked = false;
        break;
      case OverdueType.DUE_TODAY:
        this.criteria.deliveryDeadlineAfter = moment().startOf('day');
        this.criteria.deliveryDeadlineBefore = moment().endOf('day');
        this.criteria.blocked = false;
        break;
      case OverdueType.NOT_OVERDUE:
        delete this.criteria['deliveryDeadlineBefore'];
        this.criteria.deliveryDeadlineAfter = moment().add(1, 'day').startOf('day');
        this.criteria.blocked = false;
        break;
      case OverdueType.BLOCKED:
        this.criteria.blocked = true;
    }
    if (this.criteria.deliveryNumber.length > 0 ||
      this.criteria.originGlid.length > 0 || this.criteria.originCountryCode ||
      this.criteria.destinationGlid.length > 0 || this.criteria.destinationCountryCode
    ) {
      this.overdueTable.changePage(this.overdueTable.page);
    }
    // So that the modelChange of the deadline field is called before this
    setTimeout(() => this.filterMode = mode, 0);
  }

  resetFilters() {
    this.softResetFilters();
    delete this.criteria['deliveryDateBefore'];
    delete this.criteria['deliveryDateAfter'];
    this.criteria.originGlid = [];
    delete this.criteria['originCountryCode'];
    delete this.criteria['originCity'];
    delete this.criteria['originPostalCode'];
    this.criteria.destinationGlid = [];
    delete this.criteria['destinationCountryCode'];
    delete this.criteria['destinationCity'];
    delete this.criteria['destinationPostalCode'];
    this.criteria.carrierScacCode = this.selectedCarrier ? this.selectedCarrier.scacCode : null;
    this.criteria.carrierVendorNumbers = this.selectedCarrier ? this.selectedCarrier.vendorNumbers : null;
    this.criteria.deliveryNumber = [];
    this.criteria.shipmentNumber = [];
    this.metricsResult = {
      blocked: 0,
      notOverdue: 0,
      dueToday: 0,
      overdueAndPicked: 0,
      overdueAndNotProcessedYet: 0
    };
  }

  softResetFilters() {
    this.filterMode = OverdueType.CUSTOM;
    delete this.criteria['deliveryDeadlineAfter'];
    this.criteria.deliveryDeadlineBefore = moment().startOf('day');
    this.criteria.productType = OverdueCollectionProductType.ALL;
    this.criteria.collectionType = OverdueCollectionType.BOTH;
    this.criteria.pickCompleted = OverdueCollectionType.BOTH;
    this.criteria.blocked = OverdueCollectionType.BOTH;
    this.criteria.sot = OverdueCollectionType.BOTH;
    this.criteria.carrierAssigned = OverdueCollectionType.BOTH;
    this.lastActionAfter = null;
    this.lastActionBefore = null;
    this.lastActionType = ['CHEP', 'CARRIER'];
  }

  switchAdvanceMode(mode: string) {
    if (this.advancedMode !== mode) {
      this.advancedMode = mode;
      localStorage.setItem(LOCAL_STORAGE_KEYS.OVERDUE_SEARCH_MODE, mode);
    }
    this.loadPage = mode === 'actions' ? this.loadPageAction : this.loadPageSearch;
  }

  isSearchDisabled() {
    return (!this.criteria.deliveryNumber || this.criteria.deliveryNumber.length === 0)
      && (!this.criteria.originGlid || this.criteria.originGlid.length === 0)
      && (!this.criteria.destinationGlid || this.criteria.destinationGlid.length === 0)
      && !this.criteria.originCountryCode
      && !this.criteria.destinationCountryCode
      || (this.advancedMode === 'actions' && this.lastActionType.length === 0)
  }

  automaticRefresh() {
    this.automaticRefreshSubscription.unsubscribe();
    this.automaticRefreshSubscription = interval(600000)
      .subscribe(() => {
        if (!this.isSearchDisabled() && !this.showFilters) {
          this.overdueTable.changePage(this.overdueTable.page)
        }
      });
  }

  closeAndApplyFilters() {
    this.showFilters = false;
    this.appliedCriteria = {
      ...this.criteria,
      lastActionAfter: this.lastActionAfter,
      lastActionBefore: this.lastActionBefore,
      lastActionType: this.lastActionType
    }
  }

  resetModalData() {
    this.actionType = null;
    this.proposedDeliveryDate = null;
    this.proposedGiDate = null;
    this.duplicatedDeliveryNumber = null;
    this.validPODinTMS = null;
    this.commentary = null;
    this.approved = null;
    this.multiActionModalSelectedDelivery = null;
  }

  checkActionModalData(minDeliveryDate?: Moment): boolean {
    switch (this.actionType) {
      case OverdueLoadActionType.HOLIDAY:
        this.deliveryDateError = (this.proposedDeliveryDate === null && !this.deliveryDateDisabled) || moment(this.proposedDeliveryDate).isBefore(minDeliveryDate, 'day');
        this.giDateError = this.proposedGiDate === null || moment(this.proposedGiDate).isBefore(moment(), 'day');
        return this.deliveryDateError || this.giDateError;
      case OverdueLoadActionType.DUPLICATE:
        this.duplicatedDeliveryNumberError = this.duplicatedDeliveryNumber === null || this.duplicatedDeliveryNumber.length !== 10;
        this.validPODinTMSError = !this.validPODinTMS;
        return this.duplicatedDeliveryNumberError || this.validPODinTMSError;
      case OverdueLoadActionType.COMPLETE:
        this.validPODinTMSError = !this.validPODinTMS;
        return this.validPODinTMSError;
      case OverdueLoadActionType.OTHER:
        this.deliveryDateError = this.proposedDeliveryDate === null || moment(this.proposedDeliveryDate).isBefore(minDeliveryDate, 'day');
        this.giDateError = this.proposedGiDate === null || moment(this.proposedGiDate).isBefore(moment(), 'day');
        return this.deliveryDateError || this.giDateError || this.commentary === null;
      case OverdueLoadActionType.PROBLEM:
        this.commentaryError = !this.commentary;
        return this.commentaryError;
      case OverdueLoadActionType.HOLIDAY_REVIEW:
      case OverdueLoadActionType.DUPLICATE_REVIEW:
      case OverdueLoadActionType.COMPLETE_REVIEW:
      case OverdueLoadActionType.OTHER_REVIEW:
        return this.approved === null || (!this.approved && this.commentary === null);
      default:
        return true;
    }
  }

  public handleHeaderRegionFetchErrors(error: HttpErrorResponse) {
    return this.errorHandler.handleHttpError(error, 'overdue-process.errors.fetch-regions');
  }

  public handleHeaderCarrierFetchErrors(error: HttpErrorResponse) {
    return this.errorHandler.handleHttpError(error, 'overdue-process.errors.fetch-carriers');
  }

  public updateSelectedCarrier(carrier: Carrier) {
    if (carrier != null) {
      this.criteria.carrierScacCode = carrier.scacCode;
      this.criteria.carrierVendorNumbers = carrier.vendorNumbers;
    } else {
      delete this.criteria.carrierScacCode;
      delete this.criteria.carrierVendorNumbers;
    }
  }

  public updateSelectedRegion(region: Region) {
    if (region != null) {
      this.countryService.getAllByRegion(region.id)
        .subscribe(countries => {
          this.accessibleCountries = countries
          this.countriesOptions = countries.map(country => {
            return { label: country.name, value: country.shortCode }
          });
          this.countriesOptions.unshift({label: '', value: null});
        });
    }
  }

  toggleSelectOrDeselectAll() {
    if (this.isMoreDeliveriesSelectable()) {
      this.overdueTable.items.forEach(delivery => {
        if (this.isDeliverySelectable(delivery) && !this.overdueTable.isSelected(delivery)) {
          this.overdueTable.selectItem(delivery);
        }
      })
    } else {
      this.overdueTable.selectedItems.forEach(delivery => this.overdueTable.selectItem(delivery));
    }
  }

  isMoreDeliveriesSelectable() {
    return this.overdueTable.items.some(delivery => this.isDeliverySelectable(delivery) && !this.overdueTable.isSelected(delivery));
  }

  isDeliverySelectable(delivery: OverdueDelivery) {
    return this.isGlobalUser ? delivery.indicator !== OverdueDeliveryIndicator.WARNING :
      delivery.indicator !== OverdueDeliveryIndicator.HOURGLASS;
  }

  public shouldDisplayCheckbox(indicator: OverdueDeliveryIndicator): boolean {
    const isDisplayableAsManager = this.isGlobalUser && indicator !== OverdueDeliveryIndicator.WARNING;
    const isDisplayableAsCarrier = !this.isGlobalUser && indicator !== OverdueDeliveryIndicator.HOURGLASS;

    return isDisplayableAsCarrier || isDisplayableAsManager;
  }

  private generateOverdueLoadInfoRequest(delivery: OverdueDelivery): OverdueLoadActionRequest {
    const overdueLoadInfoRequest = this.generateOverdueLoadRequest(delivery, OverdueLoadActionType.INFO_REQUEST);
    overdueLoadInfoRequest.chep_commentary = this.commentary;
    return overdueLoadInfoRequest
  }

  private generateOverdueLoadActionRequest(delivery: OverdueDelivery, action: OverdueLoadActionType): OverdueLoadActionRequest {
    const overdueLoadActionRequest = this.generateOverdueLoadRequest(delivery, action);
    if (action === OverdueLoadActionType.DUPLICATE) {
      overdueLoadActionRequest.duplicated_delivery_number = this.duplicatedDeliveryNumber;
    }
    if (action === OverdueLoadActionType.HOLIDAY || action === OverdueLoadActionType.OTHER) {
      overdueLoadActionRequest.new_delivery_date = !delivery.picked ? this.proposedDeliveryDate : overdueLoadActionRequest.previous_delivery_date;
      overdueLoadActionRequest.new_gi_date = this.proposedGiDate;
    }
    if (action === OverdueLoadActionType.OTHER || action === OverdueLoadActionType.PROBLEM) {
      overdueLoadActionRequest.haulier_commentary = this.commentary;
    }
    return overdueLoadActionRequest
  }

  private generateOverdueLoadReviewRequest(delivery: OverdueDelivery, action: OverdueLoadActionType): OverdueLoadActionRequest {
    const overdueLoadActionRequest = this.generateOverdueLoadRequest(delivery, action);
    overdueLoadActionRequest.chep_commentary = this.commentary;
    overdueLoadActionRequest.status = this.approved ? OverdueLoadActionStatus.APPROVED : OverdueLoadActionStatus.REJECTED;
    return overdueLoadActionRequest
  }

  private generateOverdueLoadRequest(delivery: OverdueDelivery, action: OverdueLoadActionType): OverdueLoadActionRequest {
    const overdueLoadRequest = new OverdueLoadActionRequest();
    overdueLoadRequest.user = this.authService.getUserProfile().email;
    overdueLoadRequest.delivery_number = delivery.deliveryNumber;
    overdueLoadRequest.carrier_vendor_number = delivery.carrier.vendorNumber;
    overdueLoadRequest.origin_glid = delivery.origin.glid;
    overdueLoadRequest.origin_country = delivery.origin.address.country;
    overdueLoadRequest.destination_glid = delivery.destination.glid;
    overdueLoadRequest.destination_country = delivery.destination.address.country;
    overdueLoadRequest.previous_delivery_date = delivery.deliveryDate.format('yyyy-MM-DD');
    overdueLoadRequest.previous_gi_date = delivery.deliveryGiDate.format('yyyy-MM-DD');
    overdueLoadRequest.type = action;
    overdueLoadRequest.status = OverdueLoadActionStatus.PENDING;

    return overdueLoadRequest;
  }

  generateActionTypeLabel() {
    return this.appliedCriteria.lastActionType
      .map(type => this.translate.instant('overdue-process.filters.action.type-' + type.toLowerCase()))
      .join(', ');
  }

  ngOnDestroy() {
    this.automaticRefreshSubscription.unsubscribe();
  }
}
